var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34734 10.0842C3.34734 5.63416 7.01468 2.04597 11.4911 2.16909C15.6158 2.28342 19.0633 5.7309 19.1776 9.85556C19.3007 14.332 15.7037 17.9993 11.2625 17.9993C9.4332 17.9993 7.74463 17.3749 6.40786 16.3284C5.99451 16.003 5.96813 15.3874 6.3375 15.0092C6.65411 14.6926 7.1466 14.6662 7.49839 14.9388C8.53615 15.7567 9.84654 16.2404 11.2625 16.2404C14.6924 16.2404 17.4627 13.435 17.4187 9.99627C17.3747 6.72469 14.622 3.97198 11.3504 3.92801C7.90294 3.88404 5.10626 6.65433 5.10626 10.0842H6.68928C7.07625 10.0842 7.27852 10.5591 6.99709 10.8318L4.5434 13.2942C4.36751 13.4701 4.09488 13.4701 3.91899 13.2942L1.4653 10.8318C1.18387 10.5591 1.37735 10.0842 1.77311 10.0842H3.34734ZM10.3829 7.22672C10.3829 6.86614 10.6819 6.56712 11.0425 6.56712C11.4119 6.56712 11.7021 6.86614 11.7021 7.21792V10.2081L14.2349 11.712C14.5428 11.8966 14.6483 12.3012 14.4636 12.6178C14.2789 12.9256 13.8744 13.0311 13.5578 12.8465L10.8139 11.2195C10.55 11.0612 10.3829 10.7709 10.3829 10.4631V7.22672Z",
    fill: "#292E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemind);
export default __webpack_public_path__ + "static/media/remind.eb7d9a2a.svg";
export { ForwardRef as ReactComponent };